import { render, staticRenderFns } from "./EModalTurmasFranquia.vue?vue&type=template&id=2a36bada&scoped=true"
import script from "./EModalTurmasFranquia.vue?vue&type=script&lang=js"
export * from "./EModalTurmasFranquia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a36bada",
  null
  
)

export default component.exports